import React, { Component } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { get, noop } from 'lodash';

import '../ReactSelect/styles.css';

import ContractPickerOption from './ContractPickerOption';
import ContractPickerValue from './ContractPickerValue';

class ContractPicker extends Component {
  constructor(props) {
    super(props);
    this.state = { value: props.inputValue };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value = null) {
    const { inputName, changeFieldValue, changeCallback } = this.props;

    this.setState({ value: value });

    changeCallback(value);
    changeFieldValue(inputName, value);
  }

  mapOptions(option) {
    return {
      ...option,
      label: get(option, 'number'),
      value: get(option, 'id')
    };
  }

  render() {
    const { inputName, autoFocus, disabled, contracts, className } = this.props;

    return (
      <Select
        autofocus={autoFocus}
        cache={false}
        className={className}
        disabled={disabled}
        inputProps={{ id: inputName, autoComplete: 'off' }}
        name={inputName}
        onChange={this.handleChange}
        options={contracts.map(this.mapOptions)}
        placeholder="Select a contract..."
        value={this.state.value}
        optionComponent={ContractPickerOption}
        valueComponent={ContractPickerValue}
      />
    );
  }
}

ContractPicker.propTypes = {
  inputName: PropTypes.string.isRequired,
  changeFieldValue: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool,
  changeCallback: PropTypes.func,
  className: PropTypes.string,
  contracts: PropTypes.array,
  disabled: PropTypes.bool,
  inputValue: PropTypes.object
};

ContractPicker.defaultProps = {
  inputName: 'contracts',
  inputValue: null,
  changeFieldValue: noop,
  changeCallback: noop
};

export default ContractPicker;
